import { useRef, useState } from "react";
import { toast } from "sonner";
import { Camera, Sparkles, Upload, Link2, Trash2, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useData } from "@/context/DataContext";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export const photoUrl = (c) => (c?.photo_path ? `${process.env.REACT_APP_BACKEND_URL}/api/clients/${c.id}/photo?v=${encodeURIComponent(c.photo_v || "")}` : "");

const SIZES = {
  card: "w-[50%] opacity-[0.38]",
  tile: "w-[60%] opacity-[0.5]",
  hero: "w-full sm:w-[65%] opacity-[0.5]",
};

export const ClientBg = ({ client, variant = "card" }) => {
  const [bad, setBad] = useState(false);
  const src = photoUrl(client);
  if (!src || bad) return null;
  return (
    <div aria-hidden className={`client-bg pointer-events-none absolute inset-y-0 right-0 ${SIZES[variant]}`} data-testid={`client-bg-${variant}-${client.id}`}>
      <img src={src} alt="" loading="lazy" onError={() => setBad(true)} className="h-full w-full object-cover object-center" />
    </div>
  );
};

export const PhotoMenu = ({ client }) => {
  const { reload } = useData();
  const file = useRef(null);
  const [busy, setBusy] = useState(false);
  const run = async (fn, ok) => {
    setBusy(true);
    try { await fn(); await reload(); toast.success(ok); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const auto = () => run(() => api.post(`/clients/${client.id}/photo/auto`), "Poză găsită pe Wikipedia");
  const fromUrl = () => {
    const url = window.prompt("Lipește linkul pozei (ex: pe Facebook, clic dreapta pe poza de profil → Copiază adresa imaginii)");
    if (url) run(() => api.post(`/clients/${client.id}/photo/url`, { url }), "Poză schimbată");
  };
  const upload = (e) => {
    const f = e.target.files?.[0]; e.target.value = "";
    if (!f) return;
    const fd = new FormData(); fd.append("file", f);
    run(() => api.post(`/clients/${client.id}/photo`, fd), "Poză schimbată");
  };
  const remove = () => run(() => api.delete(`/clients/${client.id}/photo`), "Poză scoasă");
  return (
    <>
      <input ref={file} type="file" accept="image/*" className="hidden" onChange={upload} data-testid="client-photo-file" />
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button disabled={busy} data-testid="client-photo-button" title="Poza clientului" className="p-2 rounded-lg text-zinc-500 hover:text-white hover:bg-zinc-800">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Camera className="h-4 w-4" />}
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="rounded-2xl">
          <DropdownMenuItem onClick={auto} data-testid="client-photo-auto"><Sparkles className="h-4 w-4 mr-2" />Caută pe Wikipedia</DropdownMenuItem>
          <DropdownMenuItem onClick={() => file.current?.click()} data-testid="client-photo-upload"><Upload className="h-4 w-4 mr-2" />Încarcă o poză</DropdownMenuItem>
          <DropdownMenuItem onClick={fromUrl} data-testid="client-photo-url"><Link2 className="h-4 w-4 mr-2" />Lipește link de poză</DropdownMenuItem>
          {client.photo_path && <DropdownMenuItem onClick={remove} data-testid="client-photo-remove" className="text-rose-500"><Trash2 className="h-4 w-4 mr-2" />Scoate poza</DropdownMenuItem>}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};
